import { Card, Chip } from '@mui/material'
import styled from 'styled-components'

export const Container = styled.div`
    margin-left: 10px;
    margin-right: 10px;
    padding-bottom: 32px;
`

export const FilterBar = styled(Card)`
    padding: 16px;
    margin-bottom: 20px;
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    align-items: flex-end;
`

export const FilterField = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 140px;

    label {
        font-size: 12px;
        color: var(--text-secondary);
        font-weight: 600;
    }

    input,
    select {
        padding: 8px 10px;
        border: 1px solid var(--divider-contrast);
        border-radius: 4px;
        font-size: 14px;
        color: var(--text-primary);
        background: var(--background);
    }
`

export const MetricsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 12px;
    margin-bottom: 20px;
`

export const MetricCardBox = styled(Card)`
    padding: 14px 16px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    border-left: 4px solid ${({ $source }) => ($source === 'STATE' ? 'var(--info)' : 'var(--success)')};
`

export const MetricHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 8px;
`

export const MetricLabel = styled.div`
    font-size: 13px;
    color: var(--text-secondary);
    font-weight: 600;
    line-height: 1.3;
`

export const MetricValue = styled.div`
    font-size: 28px;
    font-weight: 700;
    color: var(--text-primary);
    line-height: 1.1;
`

export const MetricMeta = styled.div`
    font-size: 12px;
    color: var(--text-tertiary);
`

export const Growth = styled.span`
    font-weight: 700;
    color: ${({ $positive }) =>
        $positive ? 'var(--success)' : $positive === false ? 'var(--error)' : 'var(--text-secondary)'};
`

export const SourceChip = styled(Chip)`
    && {
        height: 22px;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: 0.02em;
    }
`

export const SectionCard = styled(Card)`
    padding: 16px;
    margin-bottom: 20px;
`

export const SectionTitle = styled.div`
    font-weight: 700;
    font-size: 16px;
    margin-bottom: 12px;
    color: var(--text-primary);
`

export const ChartContainer = styled(Card)`
    padding: 16px;
    margin-bottom: 20px;
    height: ${({ $height }) => $height || '320px'};
    display: flex;
    flex-direction: column;
`

export const InsightsList = styled.ul`
    margin: 0;
    padding-left: 18px;
    display: flex;
    flex-direction: column;
    gap: 8px;

    li {
        color: var(--text-secondary);
        font-size: 14px;
        line-height: 1.4;
    }
`

export const InsightCallout = styled.div`
    background: var(--info-base);
    border-left: 4px solid var(--info);
    padding: 10px 12px;
    border-radius: 4px;
    color: var(--text-primary);
    font-size: 14px;
`

export const FunnelStepRow = styled.div`
    display: grid;
    grid-template-columns: 36px 1fr 90px 110px 110px;
    gap: 12px;
    align-items: center;
    margin-bottom: 10px;

    @media (max-width: 800px) {
        grid-template-columns: 1fr;
        gap: 4px;
        margin-bottom: 16px;
        padding-bottom: 12px;
        border-bottom: 1px solid var(--divider-contrast);
    }
`

export const FunnelBarTrack = styled.div`
    background: var(--background-paper);
    border-radius: 4px;
    height: 28px;
    overflow: hidden;
    position: relative;
`

export const FunnelBarFill = styled.div`
    height: 100%;
    width: ${({ $pct }) => `${Math.max($pct, 2)}%`};
    background: linear-gradient(90deg, var(--highlight), var(--info));
    display: flex;
    align-items: center;
    padding-left: 8px;
    color: white;
    font-size: 12px;
    font-weight: 700;
    white-space: nowrap;
`

export const StatusBox = styled.div`
    padding: 24px;
    text-align: center;
    color: var(--text-secondary);
    background: var(--background-paper);
    border-radius: 4px;
    margin-bottom: 20px;
`

export const ErrorBox = styled(StatusBox)`
    color: var(--error);
    background: var(--error-base);
    border: 1px solid #ffb3b3;
`

export const SubNav = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 16px;
`

export const TableWrap = styled(Card)`
    padding: 8px;
    margin-bottom: 20px;
    overflow-x: auto;
`

export const ClickableRow = styled.tr`
    cursor: pointer;

    &:hover {
        background: var(--action-hover);
    }
`

export const SimpleTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;

    th,
    td {
        text-align: left;
        padding: 10px 12px;
        border-bottom: 1px solid var(--divider-contrast);
    }

    th {
        color: var(--text-secondary);
        font-size: 12px;
        text-transform: uppercase;
        letter-spacing: 0.03em;
    }
`
